// extracted by mini-css-extract-plugin
module.exports = {"Item":"Main_Item__MdoFu","Oblong":"Main_Oblong__3YCGX"};